export default class Contact {
  /**
  * Constructs a new contact instance.
  * @param {object} options - Options.
  */
  constructor (options) {
    this.element = options.element
    this.hurdler = options.hurdler
    this.closeButton = this.element.querySelector('.close')
    this.open = false

    // Enable close button
    this.closeButton.addEventListener('click', () => {
      this.toggle(false)
    })

    // Enable URL hash access
    const self = this
    this.hurdler.hurdles.push({
      test: function () {
        return this === self.element
      },
      callback: function () {
        self.toggle(true)
      }
    })
  }

  /**
   * Toggles the open state.
   * @param {Boolean} toggle - Toggle the overlay open or closed.
   */
  toggle (toggle) {
    this.element.classList.toggle('open', toggle)
    document.body.classList.toggle('contact-open')
    this.open = toggle
    if (toggle) this.closeButton.focus()
    else this.hurdler.clearHash(this.element.id)
  }

}



// WEBPACK FOOTER //
// ./components/contact/index.js